import List from "@/components/list";
import router from "@/router";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function handleDetails(vo) {
    router.push({
      path: "/audio/details",
      query: { id: vo.row.uuid }
    });
  }

  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-message", "详情", () => handleDetails(vo), ""]
      // ["icon-up", "上线", () => upLine(vo), ""],
      // ["icon-down", "下线", () => downLine(vo), ""],
    ];
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "音频名称",
      prop: "audioName",
      minWidth: "200"
    },
    {
      label: "操作",
      minWidth: "50",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
